


























































import {
  Component, Vue, PropSync, Prop, Watch,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class UserDeactivateModal extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('userValue', {}) userValueSync!: any;

  @Prop({}) userName!: string;

  @Prop({}) loading!: boolean;

  @Prop({}) approverFw!: string;

  public close() {
    this.$emit('cancel');
  }

  public add() {
    this.$emit('deactivateUser');
  }

  get canDeactivate() {
    return this.userValueSync.deactivate.toLowerCase().trim() === 'deactivate';
  }

  textFieldRules = [
    (v: any) => {
      if (v && v.toLowerCase().trim() !== 'deactivate') {
        return '“deactivate” is spelt incorrectly';
      }
      return true;
    },
  ];
}
